exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".signup p {\n  font-size: 1.25rem;\n}", ""]);

